import React from 'react'
import PT from 'prop-types'
import classNames from 'classnames'

import SvgSprite from 'src/components/SvgSprite'

import styles from './styles.module.scss'

const ColorParameters = ({ parameters, className }) => {
    const classNamesColorParameters = classNames(styles.parameters, className)
    return (
        <div className={classNamesColorParameters}>
            <p>
                <span>Hex:</span> {parameters.Hex}
            </p>
            <p>
                <span>RGB:</span> {parameters.RGB}
            </p>
            <p>
                <span>CMYK:</span> {parameters.CMYK}
            </p>
            <p>
                <span>Pantone:</span> {parameters.Pantone}
            </p>
        </div>
    )
}

const ColorDemo = ({ colorParam, logo }) => {
    return (
        <div className={styles.demo}>
            {logo && <SvgSprite name={logo} className={styles.logo} />}
            <div className={styles.colorContainer}>
                <div
                    className={styles.colorBlock}
                    style={{ backgroundColor: colorParam.Hex }}
                ></div>
                <ColorParameters parameters={colorParam} className={styles.colorParameters} />
            </div>
        </div>
    )
}

const ColorDemoSet = ({ colorSet }) => {
    return (
        <div className={styles.demoSet}>
            {colorSet.map(parameters => (
                <div className={styles.colorDemoSetContainer} key={parameters.Hex}>
                    <div
                        className={styles.colorDemoSetBlock}
                        style={{ backgroundColor: parameters.Hex }}
                        key={parameters.Hex}
                    ></div>
                    <ColorParameters
                        parameters={parameters}
                        className={styles.colorDemoSetParameters}
                    />
                </div>
            ))}
        </div>
    )
}

const ColorDemoSetPercent = ({ colorSetPercent }) => {
    return (
        <div className={styles.colorDemoSetPercent}>
            {colorSetPercent.map(({ type, Hex, Percent }) => (
                <div
                    className={styles.colorDemoSetPercentContainer}
                    style={{ minWidth: Percent - 6 + '%' }}
                    key={type}
                >
                    <div
                        className={styles.colorDemoSetPercentBlock}
                        style={{ backgroundColor: Hex }}
                    ></div>
                    <div className={styles.colorDemoSetPercentType}>
                        <p>{Percent}</p>
                        <p>{type}</p>
                    </div>
                </div>
            ))}
        </div>
    )
}

const ColourPaletteChapter = ({ colourPalette }) => {
    return (
        <>
            {colourPalette.map(({ title, text, logo, colorParam, colorSet, colorSetPercent }) => (
                <div className={styles.chapter} key={title}>
                    <div className={styles.chapterHeader}>
                        <h3 className={styles.subsectionsTitle}>{title}</h3>
                        <p className={styles.text}>{text}</p>
                    </div>
                    {colorParam && <ColorDemo colorParam={colorParam} logo={logo} />}
                    {colorSet && <ColorDemoSet colorSet={colorSet} />}
                    {colorSetPercent && <ColorDemoSetPercent colorSetPercent={colorSetPercent} />}
                </div>
            ))}
        </>
    )
}

const ColourPalette = ({ data }) => {
    return <ColourPaletteChapter colourPalette={data} />
}

ColorParameters.propTypes = {
    parameters: PT.object,
    className: PT.string,
}

ColorDemo.propTypes = {
    colorParam: PT.object,
    logo: PT.string,
}

ColorDemoSet.propTypes = {
    colorSet: PT.array,
}

ColorDemoSetPercent.propTypes = {
    colorSetPercent: PT.array,
}

ColourPaletteChapter.propTypes = {
    colourPalette: PT.array,
}

ColourPalette.propTypes = {
    data: PT.array,
}

export default ColourPalette
